module.exports = __webpack_public_path__ + "img/omexom.ed284411.png";